{
  "0056ce5e7561ee81": "Send Invite instead",
  "006f457d56bae1c7": "has already passed. How long should professionals be able to book this shift?",
  "00a1c21554fb52f6": "Extra hourly charge",
  "00cd58f655daed8a": "Type a message",
  "00fcfc375119aa6d": "Additional details",
  "010926c3ad6a439e": "Remove {{removalTotal}} shifts",
  "0148bffc150339a2": "Post block",
  "017c1e356e1333d8": "Successfully ended the negotiation with {{workerName}}",
  "01b90521f503d909": "Opens to Clipboard only ",
  "01d786e808b3bcce": "Reports of poor attendance or unprofessional conduct.",
  "02aa21b190be93e3": "Preparing removals...",
  "03c78b094b9e6759": "If your goal is to remove {{workerFirstName}} from the shift, you can DNR {{workerFirstName}}, which will un-assign them and keep the shift open for other professionals to book.",
  "04082584f8509cbc": "Contact details are required",
  "04098ef5387aa352": "Note: the professional will receive this message directly, this is not internal",
  "0427ec78ba6e5aa9": "Please confirm that this professional was a No Show.",
  "049245ad1f768a37": "Workplace ID",
  "04c8566c6fa2ffdb": "Roster shift removed",
  "04f810b21cc34f3e": "Report a safety incident to Clipboard's Trust & Safety team",
  "050eb4ea88bb108f": "Document requirements",
  "055881ac6763cba0": "Important!",
  "0690f8319c833581": "Improve fill chance",
  "069d7e9d898e4d81": "Worker ID",
  "06c578f913653c48": "Add information",
  "06f89d205e418697": "Our location data shows that this professional is still in the building.",
  "070f06bb8cfc88e9": "Pick a time before the shift starts.",
  "07548c2c6511d4d1": "Expand",
  "07555299c4f812c8": "Same as their offer — did you mean to accept?",
  "0759437ec2b49a2f": "(add)",
  "076957bce71fa868": "Submit payment",
  "08b041935798fbf6": "You",
  "08ebafa103c2961e": "Cancel {{workerFirstName}} & shift",
  "08fd1de4b04df4a2": "Stay",
  "08fdcac2f5d9611f": "Please describe what happened.",
  "090b6e496147b1a4": "Round {{roundCount}}",
  "09adde92f00886ef": "Clock in",
  "09b864507d1e8cf0": "Please select an option",
  "09f6242266631e82": "More information",
  "0a360b78d7924ccc": "{{count}} expired invites",
  "0a6d0d63ccca9bee": "Failed to download the schedule. Please try again.",
  "0b65d5e438e4bb47": "Multiple Shifts",
  "0b9447ec7bc5d691": "Shift removed",
  "0bfdbd4c5ea7d528": "This books the shift at {{payRate}}/hr pay and {{chargeRate}}/hr charge. Other open negotiations will transfer to available shifts.",
  "0d7e412d40f505a2": "Opens to Roster & Clipboard immediately",
  "0d8cc6461b0c6858": "Available Professionals",
  "0ddf1900b671e408": "Cancel unbooked shift",
  "0e113a777f41b3a5": "No shifts scheduled",
  "0e91610117029a62": "Refresh",
  "0f22fde5e0be5cc9": "Workplace Actions",
  "0f7a05f2d2b6420f": "Edit {{slotLabel}} shift times - {{dayLabel}}",
  "0f87f752eb57eac2": "Quick reply options",
  "0fe556b25edd844f": "Immediately",
  "10252e02c5f434c1": "{{shiftCount}} future shift booked",
  "1028b375c3e16096": "Do you want",
  "102942783e52049d": "Filter shift types",
  "1060c7e27852f3f2": "View candidates",
  "1071668ed0a4e232": "There is an unbooked shift in the same slot. What would you like to do?",
  "10b724964a717d29": "Add shifts mode",
  "10fe0cb9a1d28fb1": "Open shift",
  "1196833af5d37690": "Leave chat?",
  "119a718f0a036cbe": "Cancel block",
  "11a6767d5674c7e4": "Done",
  "11d1eaa116c5ddcb": "If you need help, please call operations at {{supportTelephone}} or",
  "12129eebb9eb8b03": "Waiting for response",
  "1246fc93bca00b90": "Fixed",
  "12762ab2d798a9b9": "Add a note about this removal",
  "127c043502a4a52d": "Professional types info",
  "12bc86b0c3ae7b6b": "Select a role and date to choose a professional.",
  "1367a2d916565114": "{{failed}} shift could not be removed",
  "13b9a1e9544a18b9": "When should this shift open to Clipboard?",
  "14736a2eb9f4159f": "Role",
  "148304483abafc6a": "NOC",
  "1509f561f2416598": "Save",
  "159c9a4771cb8656": "Maintain Coverage During the Winter Storm",
  "15f9bd7ac18aacd0": "Reason for removal",
  "1610dcd8f5e4eb1d": "Error downloading timesheets",
  "164e553118ec7fec": "Clipboard prohibits discrimination based on gender. By continuing, you confirm that this gender requirement is necessary to meet privacy or personal needs of the service recipients, in accordance with our",
  "16bb19636737e5ff": "You can send {{workerName}} constructive feedback to help them improve instead of blocking them.",
  "172f70e865600bcb": "{{feeAmount}} fee",
  "17303837a7538dd9": "No shifts added yet",
  "1737c4c244195b71": "Cancel Shift",
  "17c621b6accdc780": "Failed to send.",
  "17c8d95161a70ad9": "Exit bulk posting",
  "17e28e2302175d33": "Close sidebar",
  "186022c788ea6060": "Cancellation reason",
  "18b5c627fdd66dff": "Action Needed: Your contract requires a signature to avoid service interruptions.",
  "19766ed6ccb2f4a3": "Cancel",
  "19a7c78d921f0ddf": "Roster window details",
  "19aa8a3468d17bc7": "the worker",
  "19aafeafb4adfec9": "Variable Charge feature disabled.",
  "19c73a5cdf346d96": "Professional",
  "19dcad6dea244c2e": "Search professionals...",
  "19faf265a62c6297": "This shift was canceled",
  "1a0f5183da04119b": "Loading cancellation details...",
  "1a53ecdf6e5b2bfb": "Worker receives {{amount}}",
  "1aa7434e840e2e6f": "Or select a calendar slot to add a shift",
  "1ac3ed11b0cc74bf": "Incident report submitted",
  "1adcf08dfb9aae9e": "Variable Charge disabled",
  "1b015904cc17649e": "Urgent",
  "1b68f8d369e5720d": "Increase bonus",
  "1b7f5c5612251b7e": "Roster-only until {{date}}",
  "1bf3bb986c8f9da0": "Post as open shift",
  "1bf94bc3f4fcb496": "Ask an admin or corporate decision maker to enable Variable Charge for your workplace.",
  "1c88343383eec30e": "{{count}} available professional",
  "1cbd9e713d937bad": "Propose",
  "1cf9868356849393": "No shifts scheduled for this day",
  "1dbe776f8df153b6": "for cancelling this filled shift less than",
  "1de82c89364987c9": "Select shift dates for your block",
  "1e06ac23b9c0ef5b": "No professionals found matching your search.",
  "1e6f33ef90a1b9e4": "We won't charge you more than the rate you input.",
  "1e7a2f6e8859d410": "{{failed}} shifts could not be removed",
  "1ef1ab0d0f5450eb": "the winter storm",
  "1f5bb9791a310e13": "hide",
  "1f6738ae6725e558": "Extend bookability",
  "1fc9a387654d410f": "Select all",
  "1fd9ae1607aa3d80": "Invite",
  "1ff57a29d7c9d11b": "Next",
  "204c32396d64a8af": "Winter Storm Coverage",
  "2057a5d5682b3170": "Failed to clock in",
  "20591572c69c1b4e": "Fixed bonus removed",
  "2065214198dca65c": "Click the + on an upcoming slot to add a shift.",
  "20fe1bd201cd900b": "Man",
  "211d0bb8cf4f5b52": "Block",
  "217021c7d2c357c9": "Use Scheduler Agent",
  "21821f4dd188bf0b": "Acknowledge the late cancellation fee to proceed",
  "21b111cbfe6e8fca": "Default",
  "21edde0b34ffe68f": "Describe what happened",
  "2258357aa643188e": "Remove boost",
  "22ae3ae1b8f20bc7": "Unable to send invite",
  "22e56381a7a2679d": "Close shift details",
  "231d5ad2f40c41b6": "All future shifts after {{suspensionDate}} are canceled and you can't post any new shifts. Please contact support for assistance.",
  "23bbca4c71300543": "for assistance.",
  "23fa2712b869a919": "Attendance Warning",
  "24331847f1d79bdf": "Post a new {{qualificationDisplayName}} shift",
  "24b7bdf3f774ecd8": "Some queued shifts are in the past.",
  "2502bbd1f2c52382": "Failed to open this shift to Clipboard. Please try again.",
  "255381b98af5d088": "Please review and sign your",
  "257c8051763d5f71": "Share credentials",
  "259f577df539d7cd": "Next date",
  "25a30cd36d986509": "There is an unbooked shift ({{qualification}}, {{unbookedTimeRange}}) in the same slot as {{workerFirstName}} ({{qualification}}, {{bookedTimeRange}}).",
  "25a665e3b1181d73": "Currently required before booking",
  "260eae735d6581d7": "Review and sign our contract so that you can start posting shifts.",
  "2636a1e1a4daa771": "Keep Roster Priority",
  "2697224aca1d4116": "The Trust & Safety team may need to reach out for additional information, please provide the name and phone number of the person who would be best to speak with regarding this matter.",
  "273a586f155caa70": "Enable Smart Pricing",
  "276773067bcc2280": "Name and phone number",
  "27f4beaf2d0c3765": "This shift cannot be posted because its start time has already passed.",
  "2800c84cd7149ab9": "Opens to both your Roster and Clipboard professionals ",
  "2831c2ddc70ba1ad": "Do you want to proceed with posting this shift?",
  "28fa073686270307": "Part of a {{shiftCount}}-shift block",
  "29a390f9237e3c84": "Clear all",
  "2a817149e3aeea86": "Your account is Pending due to past due invoices. Pending accounts cannot fill any further shifts, but shifts that are already filled will not be affected.",
  "2ad09f56e2331223": "Rate boosted",
  "2b065c7c9ce466e5": "Today",
  "2b7d8d67147ad7cf": "Last shift: {{lastShiftDate}}",
  "2b90bd98983c5a81": "Roster shift: no cancellation fee",
  "2c9ae8e4cf7e2d3d": "This is above their offer",
  "2ca0beb5c205fd55": "This option is checked by default to maximize your chances of filling the shift.",
  "2d1f9e0d071255c9": "These times become the default for {{qualification}} in month bulk posting and the daily posting surface.",
  "2d74b9c80eb0770e": "{{rateDifference}} above posted rate",
  "2d88a3a2842eb3c9": "Su",
  "2d88b01c3fb29b61": "{{totalCharge}}/hr total",
  "2dc9bc64d8899540": "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}, time slot has passed",
  "2e218ce6e44faf2c": "You are about to post {{additionTotal}} {{qualificationLabel}} shifts.",
  "2e46006a5eebb262": "End time",
  "2e544a292f6979ed": "Shift",
  "2e811ac7cc6b5daa": "Recent Professionals",
  "2f0114c6e138bd7e": "Close shift log",
  "2f3a0951c5962882": "Slot type",
  "2f3ad8a786e16944": "Finding a replacement...",
  "2f51b30db4cd1176": "Smart Pricing",
  "2f5354e56825ae7f": "Exit block posting",
  "2f58e1382535f4d7": "No, this is only a Do Not Return request",
  "3095ee946570a186": "Open daily view for {{dateLabel}}",
  "30c80016cf2cca67": "Action needed: please ensure your contract details are up-to-date by {{deadline}}",
  "30f7b875a0165505": "Canceled shift",
  "310ca503ef36f177": "Month",
  "3140100df131cf30": "Bulk",
  "3151c8d8f3418084": ". If not, please forward this link to the person at your organization who should sign.",
  "3169d6942414f3b0": "Account usage temporarily paused",
  "31eaff37b666d873": "Show only {{label}}",
  "31fbef162594de01": "Continue",
  "324a91e31f9f93d7": "This will cancel both the shift and {{workerFirstName}}.",
  "326518a87a39b868": "Manage boost",
  "329824d70f5d0cb1": "New to your workplace",
  "32f665851af6351c": "Add any additional information that you want to share with the professional about this block.",
  "33b93476cf597a33": "Time",
  "3488b995b0dd3405": "Boosting rates helps you fill your most critical shifts quickly.",
  "3499752d53797ff5": "Please select at least one reason",
  "34faa79524f1d62d": "(optional) Send a note ",
  "3524eba34999f164": "You are seeing this banner because key details in your contract need to be verified. To avoid interruption, please discuss this with our team by {{deadline}}.",
  "355a68d4614fc7f9": "Your account is suspended",
  "35acb87b3b3529db": "Bulk posting",
  "35cba9c5c215f74b": "Shift canceled",
  "35d8b67a2ad1bde9": "Request a limit increase to continue scheduling for this week.",
  "3617bd6b5a419818": "Professional type",
  "36ac4b709817ee04": "Women only",
  "36b67fc35f565beb": "Post {{additionTotal}} & Remove {{removalTotal}}",
  "370c0a0b15a21184": "Important: Advise the facility callers that shifts cannot be posted by Clipboard users, or within Clipboard and must be posted in Staff Lion only.",
  "3778a9b61578a0d5": "Failed to add professional to the Do-Not-Return list.",
  "38a99ec1b1d35732": "Your account is pending",
  "390dd9f6966d7e83": "Save & Close",
  "3978a81d56856530": "Show charge rate",
  "39df2b7d1662cfc2": "Apply ({{count}})",
  "3a38aa141f8de7b9": "Priority window unit",
  "3a962c2d16deec6e": "Applying changes",
  "3afdff69010a1a2f": "Give the professional a second chance?",
  "3b52447110e6549a": "Reset all {{shiftGroup}} shifts",
  "3bed1cee17430c84": "Failed to update bonus",
  "3bff939c10f4d9bc": "Th",
  "3c9870f44b458bee": "Starts at {{time}} on {{day}}",
  "3c9d9544c83915b4": "Create a block of shifts",
  "3ca15ca441e1a3db": "{{hours}} hours",
  "3ccd9d6586ef9143": "Something went wrong. Please try again.",
  "3ce2791bc098fe1f": "These documents may be blocking nearby professionals from booking your shifts.",
  "3d0b55c963bda776": "Failed to remove worker from DNR list",
  "3d1b86d01a167687": "Account pending",
  "3e5616600c45579f": "Removing shifts... ({{removed}}/{{totalToRemove}})",
  "3e6983428ed0aa6c": "Collapse fill progress",
  "3ec90c0349b2f97b": "These documents are blocking nearby professionals who may be interested in your shifts.",
  "3f59dc327ce6b766": "Add any supporting context (e.g. the best phone number to reach you)",
  "3f84c2bf421a83d0": "this worker type",
  "3fb9316bd977b9ff": "Shift Log",
  "407fd659c6c7c9c7": "Remove shift",
  "408883a67ad617ca": "Unbooked shift canceled. {{workerFirstName}} is still scheduled.",
  "40b70bd43b31ecbb": "Enable Variable Charge to encourage healthcare professionals to book shifts during {{eventName}}. Once enabled, you can edit rates directly from shift actions.",
  "4126fadbb792958c": "No matching Roster staff found.",
  "4127d13bb9dac63a": "Can you tell us what happened?",
  "414fdb23cbd5f38e": "from a previous session. Continue where you left off, or start over by posting",
  "4161e0b718d06dfc": "Shift times updated",
  "420eea4285ed241f": "Open qualification filter dropdown",
  "4375644cd8a073a8": "No show detected, replaced",
  "439c9e0014d79dcb": "Expected {{time}}",
  "43a5ef392d3452ea": "New {{qualification}} shift",
  "43def83c3447de5e": "Select a date",
  "43e2e6af44325a1b": "Provide additional information about your workplace to get higher chances to fill your shifts.",
  "4465be0af1a9e4b3": "End negotiation with {{workerName}}?",
  "44936a2ec05fa2f5": "Search for a professional to invite.",
  "450538c1602e67c7": "Close add shifts",
  "457912b220fcfaf5": "All filled",
  "460b3a7da007b7af": "Chat",
  "464c4ffd019e1e96": "Edit",
  "46586575deed6e93": "{{workerName}} has been added to the Do Not Return list",
  "465e891b9fe6509d": "Keep shift",
  "46a81739c6ee7c1d": "agreement",
  "46b70ac20134bbd7": "Negotiation history ({{proposalCount}} proposals)",
  "47181cce0990730f": ". How long should professionals be able to book this shift?",
  "472c6c914210d3d9": "View timesheet",
  "476a390901962a87": "Post a new {{timeSlot}} {{qualification}} shift",
  "4774eebd95c6b9a8": "Total new shifts:",
  "4796d436b7eec305": "You've reached your weekly approved cap and are not able to post any further shifts. Please reach out to your account manager, billing representative, or billing@clipboardhealth.com for assistance.",
  "479a09de0db06ffb": "Review now",
  "4850b174b713d88c": "Required",
  "48d1d231845ef108": " max",
  "4a0df895879bfb77": "Book one worker for consecutive days as an all-or-nothing block.",
  "4a8ac266a8b7f9b3": "New shift",
  "4afa55bf7aec7ddc": "Terms of Service",
  "4be6397cfd627ad0": "Hourly bonus",
  "4c4ea06708bbe3bb": "Shift will open to Clipboard at {{time}} on {{date}}",
  "4d573631a40f8ee6": "If we fill the shift at a lower rate, you get the savings back! Easy as that.",
  "4df5cf49afa30308": "Take me there",
  "4ed0c8fa6637e0e7": "Incident details",
  "4f07b5f2af1022e1": "Remove unfilled shift",
  "4f21b405bd6be3b1": "Enter reason for removing from DNR list...",
  "4f942ae1ac336f51": "The shift start time of",
  "50789882cb44cfc0": "Remove block",
  "50e0901ed332b953": "Stop pasting",
  "51617bc0fa10901f": "Base rate",
  "51bb47c0de265566": "No, I don't want the professional to be penalized",
  "524509f2506a2d08": "Calendar view mode",
  "52828dd3cf9a3a8a": "Shift time could not be updated. Please try a different time or contact support.",
  "5435c98f684b34df": "Worked {{shiftCount}} shifts",
  "545aeab0cb25f867": "Expired invite",
  "5531037d5744cee1": "Your Latest Offer",
  "553a4a75b246d634": "Ask your facility admin to add or remove professional types",
  "558904acdc18ee4e": "Review requirements",
  "5596ceb702066266": "A note is required for this reason",
  "55b6b511e5c3158e": "Click a calendar slot to stage a shift in this block. You need at least two to post.",
  "56885bbb2cfcb446": "Fill shifts faster by making document requirements optional",
  "56aaed0fa4e25a84": "{{count}} invited",
  "56c775e0ccf199fd": "Unassign Roster",
  "56f15e2c34e48b3b": "Unable to propose this shift time",
  "572d42d7e335492c": "Add shift note",
  "579d6e9360be90bd": "Failed to unassign Roster staff. Please try again.",
  "58339f45df960408": "Wed",
  "5853a85aef33c6b2": "Copy {{dateLabel}} shifts",
  "5948473cb85291e6": "Toggle endorsements",
  "59be71333c960fd0": "Optional",
  "59bee529e6a259c3": "Increase rate",
  "59ebe97eedd6795e": "Edit time",
  "5a365d43779e1354": "Contact Clipboard",
  "5aa786bd3cbe7854": "Add or remove at least one shift before submitting",
  "5ac70032199b6599": "Feedback sent",
  "5ad1562de87b82a2": "Has active shifts in the next 2 weeks",
  "5ad3dbd1242a4cea": "Got it",
  "5ae266fd755ca628": "Your account is currently pending",
  "5b27cf835a3345d0": "There are no shifts to export for this day.",
  "5bbd271ed5b84a80": "Shifts in block",
  "5c3967e73c04beef": "Woman",
  "5c78570dfc24ed1f": "Toggle any requirement to optional and we'll update your workplace's document requirements.",
  "5d89dc684f609de3": "{{count}} canceled shift",
  "5da7346b9142aee1": "Incident details are required",
  "5dae5aaadc38d39c": "Drafting shifts",
  "5db5ce1b1688c4bc": "When unchecked:",
  "5dd0686817487f6c": "DNR {{workerFirstName}}",
  "5e1518bc8f5b7460": "Clear {{slotLabel}} shifts on {{dateLabel}}",
  "5e40f803e47d6624": "the upcoming winter storm",
  "5e6bda48493c209d": "If the invited professional doesn't accept the shift within the invite expiration time, the shift will automatically be posted to the marketplace as an open shift for other qualified professionals to claim.",
  "5e8f2802c5edc572": "for canceling this filled shift less than",
  "5eed7e9fc8f3cd68": "Start over",
  "5fc0b4a20d784166": "I understand that I will be charged a",
  "5fd5a28429682f05": "Sent home fee",
  "5ffcf02ce5a74f9e": "Bookable until: {{time}}",
  "600dc26d055ac98a": "{{count}} available professionals",
  "604bb026660c00eb": "Could not remove the shift block. Please try again.",
  "60d77ad375d1ac84": "Let the scheduler handle the rest",
  "61088da4a61587a7": "Failed to update shift types. Please contact Clipboard Health support if this issue persists.",
  "61bc3def3d4deedd": "{{count}} declined invites",
  "61f4fb5b61e0a8fd": "Add a note about this cancellation",
  "624c1c4ae0e337d5": "Time slot unavailable",
  "625371f4e73cdb4b": "Send feedback to {{workerName}}",
  "6267e14405aeca2b": "Professional gets",
  "6269327f267ba795": "Timesheet requests pending review",
  "6269e24f31555003": "Shift Block",
  "627bfc3844c6d390": "{{removed}} shifts removed",
  "628168cad5b898b0": "Are you sure you want to remove your Roster staff, {{name}}, from this shift? This will re-open the shift to the rest of your Roster and Clipboard in accordance with the Roster windows the shift was posted with.",
  "62afcc74654de6ab": "Tu",
  "637f3650adbaa3d7": "{{amount}} Boost",
  "63902b91749dd1cd": "This will un-assign them but keep the shift open for other professionals to book.",
  "63b3b86b1a73ea44": "No draft shifts yet.",
  "63dceb8800b2dd4a": "Phone",
  "6439ad295bda456e": "No shifts added",
  "6449dfdbe24d2762": "Multiple invites",
  "646662c9cc44caf4": "Memorial Day Weekend Coverage",
  "648ee100798ed22c": "Cancel block?",
  "64b66898bb10ed0e": "72 hours post suspension",
  "65659145569b894b": "Notice",
  "65b05e85db8eb9ce": "{{slotLabel}} shifts, empty",
  "661527e0f00a0bc6": "Exporting your schedule…",
  "6615bf1c8fddf2fb": "An unexpected error occurred",
  "66dab40cea1dea5c": "Fri",
  "67132f11ff8ff152": "Your shift was not added",
  "675781c7c0e04437": "No shifts staged yet",
  "6779d4437e8097e0": "Search Roster staff...",
  "67a1f8442ee4a6a7": "Negotiation history ({{proposalCount}} proposal)",
  "6952ce3ec3574335": "Block posting",
  "69774c6c1c99615a": "Failed to update shift times",
  "6a2769502a5dda78": "Previous month",
  "6a47708f4e14c122": "Review changes",
  "6aadac2f2b7a6b8e": "Go back",
  "6b85d437dab6a01d": "Cancel shift",
  "6b90bc9c4208233d": "Please select another professional to invite.",
  "6b987654a4116384": "PM",
  "6ba7ed94943d0b33": "Professionals can book without this document",
  "6c7b0e7ddfb18671": "Clocked in {{time}}",
  "6cb93237b9deea9e": "Leave posting?",
  "6cca5d22536aef55": "{{qualificationLabel}} shifts?",
  "6cfa6d04526e5a93": "Your workplace won't be charged a cancellation fee for canceling this shift.",
  "6d18fcf56e18907d": "Edit Shift Types",
  "6d320a315fe443f9": "Timesheet",
  "6dc6e21727fb5327": "This shift was canceled ($)",
  "6e2fdeeae10320d8": "Looking up shifts",
  "6f21f336aa5f9f6a": "Their Latest Offer",
  "6f92dd1d3de72e35": "Block ID:",
  "701c76afce2dc9f5": "Unable to accept the negotiation. Please try again.",
  "703390318bd55aef": "Beta",
  "7038572cdeb56103": "Notes for professionals",
  "70e88997202f3fe7": "Remove Roster shift",
  "712da63171e0c9de": "Unblock",
  "71586829d065e40f": "Issue a warning",
  "7173e79ec9298b9d": "&middot;",
  "7175517a370b5cd2": "or",
  "7186640a4e92c7ad": "for this professional's time.",
  "71c6639e24d817f0": "Part of a shift block",
  "71cdc6fd708a4ed2": "Switch view",
  "72058919d1f2d512": "DNR {{workerFirstName}} and un-assign from shift?",
  "7229bffa105473fa": "Close day panel",
  "72ff542bf8a7669f": "Couldn't copy to clipboard",
  "734b78d362d60f63": " — {{time}} on {{day}}. Until then, only your Roster can book.",
  "7450add02db5e174": "Rather discuss your required documents?",
  "745fc5be2efa1531": "Select shift type",
  "74a58af4a2da23e0": "Rush fee applies",
  "74cde7a4ea38225f": "Unable to load shift logs",
  "74e53211fef4b4d4": "Next month",
  "74fd12fee729a47d": "You are about to remove {{removalTotal}} {{qualificationLabel}} shifts.",
  "751c15306765d550": "accept booking request",
  "75c298c733082225": "Select another professional",
  "75d83f7682f56a52": "Go to today",
  "7623ef2414ccf9ec": "You have {{count}} pending requests awaiting your approval.",
  "76319028bb672ced": "Select the reasons for DNR:",
  "763d720d368de2e9": "Unable to update this shift time",
  "7661cdeaf93ba1a4": "This shift will be canceled.",
  "76900f1bfd16c8d4": "Back",
  "76a13f805cdc1b8b": "Send invite",
  "76eff1e784e83cf5": "Error loading timesheet",
  "76f69e45c2791d57": "this worker",
  "77a562b657da74bf": "a fee",
  "77df31107c9cd6a2": "Enable block booking",
  "77e358417e9b5bd9": "Extend booking window",
  "79415acaf556f49e": "Worked {{shiftCount}} shift",
  "796be7af1a22b31c": "This professional cannot receive this invite. Please review the issues below.",
  "799740596bd4c378": "Paste shifts onto {{dateLabel}}",
  "79a9d7d5e52b144a": "Starred Professionals",
  "7af129ac87e6c3fb": "Remove one {{slotLabel}} shift on {{dateLabel}}",
  "7b05e32e8323fa92": "Invited:",
  "7b4339cf860e01a6": "Qualifications",
  "7bb59e6f16e56dda": "Are you sure you want to cancel this {{shiftCount}}-shift block from {{dateRange}}?",
  "7bf1d1ae493c65f4": "Do you want to proceed with sending this invite?",
  "7c94eda094c800ff": "{{hours}} hour",
  "7cb0b1ba74933007": "Book {{workerName}} for this shift?",
  "7cb1dcb673d3dcc9": "{{shiftCount}} shifts",
  "7d0bd0942884cd45": "Finish signing up",
  "7d1e234cd60235a4": "Rush fee",
  "7d5208aa55606653": "Open to Clipboard now",
  "7d9d83e30ac123f3": "How do you want to apply this time change?",
  "7d9eb7acb13e2462": "Close",
  "7da11212ed340ea7": "Thu",
  "7ddacf9693938efc": "{{qualification}} shift",
  "7e05c585ff758063": "We'll use our best in class pricing algorithms to find you a professional at the lowest rate possible.",
  "7e16ac00450dfbef": "Show more shift types",
  "7e271cc38a9f2950": "Propose a new shift time",
  "7e6fefff0f0aeb6c": "Hidden",
  "7e95d39fd43fb729": "Post shifts with rush fee",
  "7ed1f0d4b2b0faeb": "Post a new {{timeSlot}} shift",
  "7fc5eb1dfd5320ef": "This shift starts soon at",
  "802ab5569606ed0d": "Failed to create block",
  "80bb74682ba302ea": "Has shifts queued for bulk posting",
  "80f5498e5eab1fe5": "More posting options",
  "813dbaacd7d32e4a": "Currently on Do Not Return list",
  "814f4ed2d5bd33e3": "Contact support",
  "8169693101a4536c": "Start date",
  "81b43c68e7a45f2d": "Give the professional another chance? Issue a warning instead of a DNR",
  "822bab8d41bca8d7": "Quantity",
  "8235980b80addfc7": "Send feedback",
  "82d1af9a1ba4f3ad": "All {{totalShifts}} filled",
  "82fc2d12a96f469a": "Note: Roster workers do not have rates and will not see or receive rate changes.",
  "83221ab96f11b0cf": "Professionals of any gender will be able to view new shifts you post. This will not affect shifts you've already posted.",
  "832c49d5487a2b06": "Enable instant book",
  "833b4c5ff49767b7": "directly to the professional",
  "837e8d24e44d8288": "Post shift with rush fee",
  "83a03d5fe0e91d5a": "Adding {{qualificationLabel}} shifts",
  "849d7b529c20c7f4": "Post as open shift if declined",
  "84b00ba36056eea9": "The professional is leaving without my permission.",
  "8628e564d722308d": ". Until then, only your Roster can book.",
  "86a3835bd36c3318": "Rate proposal sent successfully",
  "86f4050aa4cd9953": "Shift block",
  "8734ab3e91d7adb4": "Failed to update charge rate",
  "873567be309f124e": "Continue anyway",
  "8795fb4cfe8a7f38": "contact support online",
  "879d8fb64f88733e": "Only",
  "87fbe4fb79b1d700": "Attach file",
  "8850a960f4e7675d": "Rate Proposals ({{proposalCount}})",
  "8918efd027c62b04": "Boost rate",
  "89713b9c9c1b8f65": "Accept",
  "897a71d5318d675b": "Loading shifts...",
  "89bf5c6461335cb0": "Fill Guarantee applied",
  "8a61b9ed2af8095b": "You have 1 pending request awaiting your approval.",
  "8a9de5c92e68f67c": "Replacing...",
  "8ad5acfe0b6db645": "Declined invite",
  "8b045ff0baac5c19": "Pending requests to book",
  "8b143481ef6d18ac": "Bonus amount",
  "8bb5c11f9e2c57a9": "Any qualified professional can book",
  "8ce311a77e2d0755": "No shift logs yet",
  "8d3085ef72407e54": "Saving ",
  "8d525e5f158b9afe": "Copied",
  "8d5b9323d5e35205": "{{workerName}} has worked {{shiftCount}} shifts at {{workplaceName}}. Consider sending constructive feedback to help them improve instead of blocking them.",
  "8d75f799b447a218": "Close invite drawer",
  "8d8c27652b244dfe": "Pending rate proposals",
  "8dd52892f76fe969": "{{count}} date selected",
  "8de7fac328e8be53": "{{count}} canceled shifts",
  "8e27a3ae187f2af8": " before shift start. Set an earlier time to give professionals more time to book.",
  "8e36307961c6d5c1": "{{count}} Shifts",
  "8ebd5b705d7e64d2": "Boost type",
  "8f2364e11b8be3ff": "Day",
  "8fbb370cbd171142": "Use the + button on a calendar slot to add shifts. They'll show up here grouped by day.",
  "909cb81127c5e194": "Book",
  "911f369d5d37788c": "Prorated bonus from boost",
  "91d6c413d45572ff": "or describe your shifts below",
  "91f7609e000bb439": "{{days}} days before shift start",
  "924ef415081790aa": "Posting mode",
  "92760e47580947ab": "Your chat with the agent will be reset if you leave, but draft shifts will remain saved.",
  "929bbe292fcd5071": "This professional cannot receive this invite.",
  "92aa4b51d483db30": " from your ",
  "92f5e0bdde0f12fb": "Your account will be placed on hold due to missed payments",
  "930ca66d1a74fc9d": "Must be at least {{minLength}} characters",
  "938220cf22b2c66e": "breakPolicies requiresLunchBreak",
  "93b41151c11932da": "Click on a slot to begin",
  "93e76940cf397ea3": "Edit roster window for this shift",
  "942087cc2d41e013": "Retry",
  "94cf88d91055c26a": "Your workplace won't be charged a cancellation fee for cancelling this shift.",
  "94db8329fecc5718": "All upcoming shifts for the shift block have been removed",
  "958020550633c6c7": "Failed to update shift note",
  "95836f82062da8db": "Show fewer shift types",
  "9593eab7fed12fc4": "Do you no longer need coverage for this shift?",
  "95e445f6311803b9": "All shifts",
  "95f7a41f508314ad": "Other Professionals",
  "963a5fc0081a9f94": "At least one worker type must be visible.",
  "964b67c944a13ef9": "View contract",
  "9669ede056b7aa5f": "This message will be sent directly to the professional via chat. This action cannot be undone.",
  "9681395de456c72b": "Contact details",
  "968e3c7a50310a66": "{{count}} Shift",
  "969ccbd3cf6300ec": "Email",
  "96b562d99d00fdab": "No shifts on this day",
  "97112eb82d331ca8": "(optional) Send a note directly to the professional about the cancellation",
  "974af971aadee8b9": "You proposed {{payRate}}/hr",
  "977844fd4358f110": "Select a role",
  "9841ea515c1c0ae1": "view worker documents",
  "9872a19ccc59e398": "You are about to post {{additionTotal}} and remove {{removalTotal}} {{qualificationLabel}} shifts.",
  "98917ffe0f77381a": "Failed to send proposal. Try again.",
  "98965ca31b020f81": "Posting shifts",
  "98b907a974c7e66f": "This shift starts soon",
  "99810648bc14cd3b": "No replacement requested",
  "99c40ab405926cb5": "Date",
  "9a7b8a4e1d434df4": "Select {{date}}, today",
  "9af8ecb103b1dcf4": "Clipboard fee",
  "9bee0cca8c8afc57": "Edit {{slotLabel}} shift times on {{dateLabel}}",
  "9c7502853539b248": "Decrease rate",
  "9cbf17bb0535e1ff": "The shift will remain available for other qualified professionals to pick up until it is filled or expires.",
  "9cd196d90bf55de2": "One professional books an entire block",
  "9cd54a598bb5a987": "Late cancellation fee",
  "9cf43b59441404fb": "Unable to end the negotiation. Please try again.",
  "9da8797fa5a6cb02": "No, block anyway",
  "9db29e4b9988dc6f": "Add multiple shifts",
  "9dc63df81e577b4f": "Search for a Roster worker to assign.",
  "9e8197ce9e5f9592": "Show sidebar",
  "9ec09d9fdf3dd405": "Remove {{slotLabel}} shift from block",
  "9ec49dbdc7bdcabf": "These times apply to every shift staged for this {{slotLabel}} slot on {{dayLabel}}. Other days use the workplace default.",
  "9ef3ca2074b88e30": "Fixed bonus applied successfully",
  "9f48f1c96fafcc8a": "Add one {{slotLabel}} shift on {{dateLabel}}",
  "9fd728c66c9a256b": "Add",
  "a045379eaab1e76a": "The Missed Punch Request feature is NOT live for this workplace. Please use the shift verification tool for verifying shifts.",
  "a08c01726fe761a1": "Missing documents:",
  "a0cdf03cc74c5033": "No show, replacing...",
  "a0dcca719b0b6692": "Remove {{slotLabel}} shift",
  "a0e63d7c7125d29a": "Not now",
  "a110c8bf63a88829": "Send feedback instead?",
  "a21114e9cf645f9c": "Select shifts for the block",
  "a22f7d394ae4188b": "Base {{baseCharge}} · Pay +{{payDelta}} · Charge +{{chargeDelta}} →",
  "a2b280cfc9dde794": "Can you describe what happened?",
  "a2d285b352873457": "Decline",
  "a2e7e693ab5bc9c0": "Require approval to book",
  "a411cdc69171bcef": "You have past due invoices. If you do not submit a payment by {{pendingDate}}, your account will be blocked from filling any further shifts. Any shifts that are already filled will not be affected.",
  "a4516904313c6ff4": "Memorial Day Weekend",
  "a4814914c30ae9fe": "Failed to add worker to DNR list",
  "a52ace420f2175d0": "All",
  "a55076cebaa7f342": "Enable Variable Charge to help fill shifts during {{eventName}}. You can edit rates directly from shift actions.",
  "a5554622c655c7a7": "Post",
  "a55e892ad25cbf89": "Shift cancelled",
  "a597b36badcfaf6a": "Unable to load slot details.",
  "a600b900f83db6cb": "Close panel",
  "a60c0027df397eed": "Only post a shift in Clipboard when you are absolutely certain — this will likely break the shift's synchronization with the Staff Lion system.",
  "a648708bed4aa733": "Payment due",
  "a657c440f8f62100": "Add hourly bonus",
  "a67b04cd5c491d4d": "Worker",
  "a6fa394a43f903b1": "Thank you for submitting an incident report to Clipboard's Trust & Safety team. Someone from the team may reach out to you via phone or email.",
  "a7467746c201c0e9": "Total charge",
  "a857b017bb13651f": "Post Shifts",
  "a87abb24997dcec6": "Select qualification",
  "a93acb02cbaea116": "{{count}} shift",
  "a93bcdae603b8047": "Boost this shift",
  "a951efc79deb7ff3": "Sa",
  "a9e590a172099aac": "Talk to someone from our team.",
  "a9faf11e6bd5bec7": "Cancel shift invite",
  "aa0fd4c61d979a91": "{{count}} shifts copied",
  "aa3e775302e19635": "View {{shiftCount}}-shift block details",
  "aa4341053cc3c078": "Are you sure you want to remove this {{shiftCount}}-shift block from {{dateRange}}?",
  "aab34f0b19ac7c0a": "This shift time proposal may result in the professional having more than 16.5 consecutive hours of shifts booked. Are you sure you want to propose this shift time?",
  "aac77df347205252": "Feedback",
  "abb3f3a4080a44fb": "Unable to load shift details",
  "ac116c1cca856f1a": "Please enter at least {{minLength}} characters",
  "ad4d4bd466344f36": "Have an administrator contact your account manager or support to enable this feature.",
  "aecb793011851118": "Post all shifts",
  "af1515f48822838a": "Edit {{slotLabel}} shift times",
  "af3f12e161fdb1cb": "You have",
  "afb9da9df3ada8ad": "Found {{count}} professionals",
  "afe1c6b53421f9f7": "Reset all {{slotLabel}} shifts",
  "aff0766a5290e117": "Review",
  "b05be2523b007caa": "Increase hourly bonus",
  "b0641e791fa87d39": "They can still book at the posted rate. Other negotiations for this shift stay open.",
  "b06fff5032205ff2": "This shift has not been posted or invited yet. Discard this draft?",
  "b0a7b3c03119094c": "this shift",
  "b1b5289afe723700": "You can only create a maximum of {{maximumShiftCount}} shifts at a time.",
  "b2eb2fd9a90f488b": "to re-enroll your account. Pending status means you are not able to accept further shifts, but any shifts that are already filled will not be affected. If you're not authorized to sign this agreement, please forward this link to the relevant person at your organization. For any questions, please contact",
  "b40a57c0c9b17557": "Invite sent",
  "b48fd06fbc1b8006": "Remove block?",
  "b4aba91e4f554b31": "Charge Rate",
  "b4ce0fb76e4ef3db": "Fixed bonus applied to {{count}} shifts",
  "b4dc66dde806261b": "off",
  "b4e929d8bcfe0418": "Documents",
  "b50e079820bbe89d": "{{slotLabel}} start time",
  "b52874990d85754c": "Variable Charge feature enabled. You can now edit rates on shift cards.",
  "b578f4df5f37b03f": "Min rate",
  "b59c75232481974b": "these {{count}} shifts",
  "b5c120b316c237a0": "Saved",
  "b6099513e753b3e6": "Boost again",
  "b617615f96e8228c": "Add internal note",
  "b68d849723673e57": "Accept Rate",
  "b749e205302cc219": "Copy to clipboard",
  "b753927f1b81553b": "Delete this shift? It will be removed from your internal Roster and Clipboard (if posted).",
  "b758a5f34167b9cd": "DOB",
  "b764cdc0eab71374": "Unknown",
  "b7c0d007120b9767": "Edit shift note",
  "b7f93e7d8bae15f2": "Apply this bonus to all {{shiftCount}} unfilled {{qualificationName}} shifts from {{startTime}} - {{endTime}}",
  "b82274d4b5cf3655": "{{filledShiftsCount}} of {{totalShifts}} filled",
  "b86cab6fac65cc6c": "{{count}} qualifications selected",
  "b8c23620ff8c635e": "No cancellation fee",
  "b8d31e852725afb1": "on",
  "b8e9fce9abb5b491": "Expand fill progress",
  "b96a6050465ef6df": "Helpful information for professional (optional)",
  "b96d5ff6260b4c81": "The block has been created successfully",
  "b98884ab0a39304e": "This shift will be opened to Clipboard professionals on",
  "b98d1643c4f391bd": "Write a note to the professional...",
  "b9f4177e92b021c2": "We'll post an urgent shift and start looking for a replacement professional. No extra charge.",
  "bab37d62472990c0": "See more",
  "babe9dda85036fe4": "Start time",
  "bb55bf0aa5b6e211": "Cannot send invites",
  "bb87bbf83341c1b4": "Does this do-not-return involve a safety, clinical, abuse, harassment, theft, impairment, or other serious safety incident?",
  "bba4c17d03c1f365": "Your usage cap has been reached",
  "bbb0da2768b15762": "Clocked out {{time}}",
  "bc17b7d2c6a26cbf": "{{postedShiftCount}} of {{totalPendingShifts}} posted",
  "bc5b45ae7b60692a": "Reset to default",
  "bc79cdffbaa8df09": "More options",
  "bcdb701c2919f1ff": "Apply to all {{slotLabel}} shifts",
  "bd4f680faabab58b": "Cancel Invite",
  "bd59825da9bf173a": "Remove {{slotLabel}} shift on {{dateLabel}} from block",
  "be1e4a39db83f8cc": "{{shiftCount}} future shifts booked",
  "be6eb1fc3b05bf9d": "Collapse",
  "bf180fbea0d8415e": "Roster has not been updated in over 10 days and may be out of date",
  "bf46c8950bfc26ca": "One professional books all the shifts",
  "bfab8caee6addf35": "Shift opened to Clipboard workers",
  "bfb925ed2f8e4326": "Post {{additionTotal}} shifts",
  "bfcd93723edb6e2e": "Add shift",
  "bfd5b1e3bd191611": "Set this as my default",
  "c0749d7dc469e903": "Unassign Roster staff",
  "c088da77a7c4a41f": "Charge {{totalCharge}}/hr exceeds {{stateCode}}max {{maxCharge}}/hr",
  "c136428eb4f99a17": "Failed to remove Roster shift. Please try again.",
  "c1a2763f82ebe0b9": "{{removed}} shift removed",
  "c1ad5dcf2e0576ad": "Send Invite",
  "c1b116d9c6461f6a": "Failed to update worker type visibility",
  "c1b24f6b30395848": "Request limit increase",
  "c1ef7fe3e0d8054c": "Unknown Worker",
  "c1f1c8819e337780": "Boosted",
  "c2d9845f4dbeec1e": "I understand that marking the professional a No Show will result in an account restriction.",
  "c2e06d2bdfe3244f": "Choose which professional types are visible on the calendar for all users at this workplace.",
  "c2ff8acd4ad3c7b4": "Some shifts start soon",
  "c335224245004da8": "Charge rate updated successfully",
  "c34d1e939dc17e1c": "Must be at least 20 characters",
  "c44d1f7712968552": "{{count}} expired invite",
  "c460db5e7ffae1dc": "Could not cancel the shift block. Please try again.",
  "c488a7f2c2b4238d": "Yes, report this to Trust & Safety",
  "c51b1b8741a15a40": "We couldn't load the charge details. Please try again.",
  "c57456e4427dcf0b": "Send invites",
  "c5f0e3e0ade58c8e": "Smart Pricing info",
  "c60902c99a24da71": "Prorated bonus",
  "c6a473c0b60eab88": "Close shift block details",
  "c6e9bec0b2a092db": "{{count}} candidates are awaiting your review. Please review them now and choose to request an interview or decline.",
  "c784a48b1fa5dd69": "{{days}} day before shift start",
  "c799e3d57799950e": "Found {{count}} professional",
  "c83fe38303acb6ad": "Fill in-progress",
  "c8c1b56f18d10c2d": "Do you want to proceed with posting {{subject}}?",
  "c8df66c5fe3f97d0": "Close dialog",
  "c8f48a68649d1cae": "AM",
  "c97743a83995f818": "Upload your schedule here",
  "c9a7e734d5cc5a0d": "Roster staff assigned to the shift",
  "ca2ca4c1f172f1c7": "{{count}} declined invite",
  "ca4153b6bb219647": "Unfilled",
  "ca473770db3a6529": "Maintain Coverage During Memorial Day Weekend",
  "cad7947500ea2aaf": "Charge rate",
  "cadd7bae7f56119d": "All upcoming shifts for the shift block have been canceled",
  "cae6753d03d327be": "This shift will now be open to be claimed by all Clipboard workers. Your Roster staff will still have access to this shift.",
  "cb35a570b6e4baa6": "Account suspended",
  "cb86a681fcfaf0da": "No {{timeSlot}} shifts were posted",
  "cc93c1c99d40314f": "Tap + to post a shift",
  "ccaaff90680a3fbe": "We'll find a replacement professional",
  "cd72097a6f69799d": "{{count}} shifts",
  "cdbdac1da505071e": "Send invite with rush fee",
  "cdc874b9a974f470": "at the same time",
  "cdcf0c647f9af9c6": "Optional — tell the professional anything they should know.",
  "cdebca45b801e8b2": "Require gender-specific {{serviceTerm}}",
  "ce48147aa61ee906": "Enable priority access",
  "cea4d2e010b8fd52": "Clear selection",
  "ceebd437e1769f44": "Unable to load monthly counts.",
  "cfa969c682dfd6e6": "Bulk posting failed",
  "cfb80983bacc8ce9": "Work history",
  "cff929e95dd0ab8f": "Someone from the Clipboard team will reach out within 1 business day to review your workplace's document requirements with you.",
  "d07dd878a6dec3b7": "Enter rate",
  "d08a6f77815f3a67": "Add {{slotLabel}} shift",
  "d0a4d1e4d6f27b61": "Shift type",
  "d0ec86bc8fd41126": "Switching views will leave posting mode. Your staged shifts stay saved and you can resume them later.",
  "d11c6831f1ab61dd": "Only the professional you invite can book",
  "d17d84a604994b72": "Exit",
  "d1a5968d27cc4b91": "Multiple shifts",
  "d1aa2cfcd4669bc8": "{{workerName}} has been removed from the Do Not Return list",
  "d1cee48d0de28c45": "See less",
  "d1db29ebc76d9f61": "Hide sidebar",
  "d1eb39b09bf52b68": "Tue",
  "d2288d4570696201": "shifts. Select a different tab above the calendar to switch.",
  "d23e867e38e89ebf": "Mo",
  "d2562b884e5fc0ca": "This feature requires admin approval",
  "d2c25c86582dcca3": "Failed to load charge rate limits",
  "d3074e49b63e8eea": "Could not load shift block details.",
  "d3159e27a9330927": "Post shifts",
  "d3a27d96cd0791a2": "Scheduler",
  "d3c9f5ad4f566898": "Add Shift",
  "d3eefb6a33d18b7e": "Additional details (optional)",
  "d42fc22372f96b6b": "Posting is taking longer than expected. Please refresh and check your calendar.",
  "d46233513e29dea8": "Save & Exit",
  "d471b71ef926577f": "Endorsements",
  "d4788f256f730423": "View profile",
  "d47d7cb0e4f8fd2b": "More",
  "d4d66b7ef234d431": "Something went wrong while posting shifts. Please try again.",
  "d5147e7b7ca9eb2e": "End Negotiation",
  "d56d526dae68d973": "Update Roster",
  "d5d0a30b517e3bea": "Calendar",
  "d62c7b74e509674f": "Update charge rate for all {{shiftCount}} unfilled {{qualificationName}} shifts from {{startTime}} - {{endTime}}",
  "d632617f97e809ea": "Assign a {{qualification}} from your Roster.",
  "d6465f6688fbde51": "Multiple Invites",
  "d64bad115a57a139": "(remove)",
  "d696a35bdd1883da": "Profile",
  "d6df29adae3ef050": "No professional types are included in your contract yet. Please contact support to update your contract.",
  "d6eafe8235910042": "Download",
  "d6f0922393cee1c1": "All shifts after {{suspensionDate}} are canceled, and new shifts can't be posted. Please submit a payment or contact us at billing@clipboardhealth.com for assistance.",
  "d7022e3f612fdabf": "Yes, I want the professional to be penalized",
  "d7ac4069df5d4780": "Edit {{qualification}} shift times",
  "d7cbbb688b2e506c": "selected",
  "d848a26fb462bf92": "Override roster window mode",
  "d87fdadabf8915bc": "Shift couldn't be deleted",
  "d8b0b02c84a10f7b": "Assign Roster",
  "d8e450d7767f5756": "Failed to assign Roster staff. Please try again.",
  "d900a0ee4fa75a07": "Your account is inactive",
  "d91ef4ac7730f4e3": "Shifts posted but quiz update failed",
  "d97968b23b2ee87b": "Add {{workerName}} to Do Not Return list",
  "da1f3c19871c3a58": "so we can assist.",
  "da412499d3a8c4d2": "Max rate",
  "db0195a83f9872f2": "Export schedule",
  "db18f17fe5320076": "Sun",
  "dbe0534bb63e57d7": " about the cancellation",
  "dc1011d87ddbaa17": "Worker asked me to cancel",
  "dc90c87e122b2490": "Searching for Replacement",
  "dcacb8cfa6feed47": "Calendar & Filters",
  "dcbf6f252e4b9118": "Re-enable this qualification in your workplace settings, or choose a different qualification for this shift.",
  "dd290a557b7edd34": "Edit {{slotLabel}} shift times on {{dateLabel}} (custom)",
  "dd98fb3f6ec2f773": "Accept {{payRate}}/hr from {{workerName}}?",
  "dd999b9a72aa9249": "Review the queued changes before applying them.",
  "ddebf65d3bc063fa": "Removal reason",
  "dea89b13bcd4fe8a": "{{count}} {{professionals}} arriving soon at your facility for the first time. Take a moment to share {{credentialsType}} credentials!",
  "ded82aa591619802": "Cancel {{workerFirstName}} and shift",
  "def235b01a680a58": "The Missed Punch Request feature is live for this workplace. Please follow the MPR SOP for any shift verification or adjustment requests.",
  "df0fe79898ef413e": "Print",
  "df1a13a9f5372caf": "Add Shifts",
  "df2c3b3e38746905": "You have unposted shifts",
  "df2d0dc8e24c0ff3": "Previous date",
  "df615262aa1a1669": "Save times",
  "dfcea7f40973d63e": "{{time}} on {{day}}",
  "dfe36467102a316b": "Write your feedback",
  "e0601a73cc98e05a": "Edit time (custom)",
  "e08fe67fcc389bcd": "All qualifications selected",
  "e0c7fc6777c19333": "Review invite",
  "e0e5e52c71ebbe8d": "Unable to enable {{typesList}}. Please contact Clipboard Health support to configure charge rates for your workplace.",
  "e11b517eed438862": "{{workerName}} has worked {{shiftCount}} shifts. Consider sending constructive feedback to help them improve instead of blocking them.",
  "e11f44d32d49dfd2": "Keep block",
  "e1cd25b85547bd46": "Failed to create shifts",
  "e1eeb204d8795e72": "Remove Shift",
  "e21f935f11d7e966": "Copy",
  "e2afc41c0dd59c29": "Opens to Clipboard ",
  "e3d375c44fd8439c": "Cancel filled shift",
  "e46f0ad78f6d48fa": "Failed to load shifts. Please try again.",
  "e49583f95ccf5db7": "Please describe the issue so we can take appropriate action.",
  "e495b3551c367816": "Successfully accepted the negotiation and assigned the shift to {{workerName}}",
  "e4b6399c711b5c9b": "We've identified a change of ownership for this facility and a new contract is required to continue using our platform. You're unable to book new shifts until the updated contract is in place.",
  "e51258e58c381769": "Your account is suspended for missing payments",
  "e6f4e5011fc9f121": "Canceled shift ($)",
  "e708aa6b31284129": "Describe the issue",
  "e7a5b8c3fcb5b8e4": "{{days}} day after posting",
  "e7ecdf0d31e14d57": "{{count}} dates selected",
  "e7f458685df1a5c3": "Visible on calendar",
  "e7f5f530c6b8b2af": "This worker will be able to book shifts at your facility again.",
  "e86b72f85e2114d0": "Hourly bonus: {{bonus}}",
  "e8a4d4ad48f48070": "before the shift starts.",
  "e9140d190970aa34": "Account suspended for missing payments",
  "e981ddae45d8f4ca": "Warning",
  "e9999e73a580bacb": "I understand that my workplace will be charged a",
  "e9d5e587f2818276": "Block / DNR",
  "ea100174d29b183e": "Baseline: {{hours}} hrs/week",
  "ea210e2ebaa3a507": "{{dateLabel}} shift controls",
  "ea2cc40d45cd99cf": "Select {{date}}",
  "ea61bc15688d1e48": "Copied!",
  "ea62f7ad88138eed": "We want to help you maintain coverage during {{eventName}}. Ask an admin or corporate decision maker to enable Variable Charge for your workplace.",
  "ea8c089e16a3de62": "Dismiss banner",
  "eaa0049d20863b68": "to be penalized?",
  "eab0cd8fdf9bccec": "Hourly",
  "eb365f0fe1e6acbb": "Shifts in this block",
  "eb69d86d6eecdb6c": "Review shifts",
  "ebd61f0962a28e4f": "Your workplace won't be charged a cancellation fee for cancelling this Roster shift.",
  "ebf12ef47cf575b3": "Draft",
  "ebfef07e2d2b1c17": "Pick a time in the future.",
  "ec116342c6998ca9": "Pick a time",
  "ec53b715f5a4b205": "The shift will only be visible to the invited professional. If they don't accept, the shift won't be posted and you'll need to manually post it or invite someone else.",
  "ec6ef45d6169b644": "Show all shift types",
  "ecfe8570868995eb": "Decrease bonus",
  "ed373fec624c3479": "Clipboard has discontinued the Childcare and Education offerings and pended all outstanding accounts. Pending accounts cannot post any new shifts, but future shifts that are already posted will still be honored and worked. Please submit payment on your remaining balance or contact us at billing@clipboardworks.com if you have any questions.",
  "ed77e681ad80e655": "Please ensure your contract details are up-to-date by {{deadline}}. If you have any questions, please reach out to",
  "edc48b5a5ae34fe6": "Time and license editing is disabled for Roster shifts.",
  "edd32138d380825b": "Selected Professional",
  "ee0f0495791d4693": "Shift ID",
  "ee36016ce41c648c": "Total shifts: {{shiftCount}}",
  "ee82285b2bef5f54": "Edit charge rate",
  "eebdd24a77d9ad32": "Confirm",
  "eed8f901692d0856": "Fr",
  "ef3d67c37d8e0333": "Your response is anonymous and for Clipboard's internal use only.",
  "ef80bb8ce97b8d1d": "Error printing timesheets",
  "ef8a7e8d561b416e": "Shifts posted successfully",
  "f0db9bf158906717": "Remove from Do Not Return list?",
  "f120021c2869066c": "We'll remove the worker and stop searching for a replacement.",
  "f16a947f6c0952a4": "Men only",
  "f23e6c26374bbc50": "Make document requirements optional",
  "f26e99281ea8898f": "Dismiss available workers panel",
  "f286dc334b128966": "Shift time proposal sent",
  "f322556f03221d2d": "Yes, send feedback",
  "f3380f7b44bd70af": "Paste",
  "f37da14136c22f95": "Remove from Do Not Return list",
  "f3dfa2aef6491990": "Decrease hourly bonus",
  "f3fe997b8d1ce818": "We",
  "f405af18c7f9b71e": "This shift will be cancelled.",
  "f40d7f51f69edfaf": "Mon",
  "f42dfa382dc36c83": "If you're authorized to sign this contract, please do so",
  "f491d58207eb7fcb": "Sent home at {{time}}",
  "f4b4637b4395a437": "Do Not Return",
  "f50dcf0f149ab2b2": "You're posting",
  "f53a2330667daa5f": "Your workplace will be charged {{feeDisplay}} for this professional's time.",
  "f60420bece08cd42": "When checked:",
  "f667a06d7d7ff1b8": "Variable Charge enabled",
  "f67a23ce7574418d": "Your account is inactive. Please reach out to Clipboard Health Support",
  "f6a30a10bc27be0a": "Report an Issue",
  "f6f4688ff23d50c6": "Send",
  "f72230410d232ea6": "Roster staff unassigned from the shift",
  "f7303adee2857203": "{{days}} days after posting",
  "f731562ef07f6f72": "No available professionals found.",
  "f7c233114080719b": "Edit shift time",
  "f8588524fa4a7822": "Apply to all {{shiftGroup}} shifts",
  "f8b506de10564a0c": "Blocked Professional",
  "f8d399737b4e2b24": "If not accepted, post as open shift",
  "f8d46c2570e70736": "More actions",
  "f8e47f10d5dc8923": "Bulk posting complete",
  "f929f2c4c375f54e": "Add {{slotLabel}} shift to block",
  "fa1c346ae61602cd": "Please select a different time slot to send invites.",
  "fa5f3757ef2291d2": "Available for different professionals to book",
  "fb3976bbbd316226": "Configure block",
  "fb75f6d7a6206272": "The professional has been added to the Do-Not-Return list.",
  "fb8108ee5a3955b5": "Failed to send shift time proposal",
  "fbab7e0010099396": "Professional in the building",
  "fbbf67422e5e3648": "Shift Types",
  "fbed4f5f88700625": "Only professionals of your selected gender will be able to view new shifts you post. This will not affect shifts you've already posted.",
  "fc00ac0a095eedbf": "{{shiftCount}} shift",
  "fc6e4a408d56be96": "Leave",
  "fc73814ad8b16b82": "Fill Guarantee is only supported for boosts on single shifts",
  "fc7b2579f42a3c64": "Add to Do Not Return list",
  "fc8a478384f2d805": "The professional left with my permission.",
  "fca60b3c431a22a8": "This professional has been blocked by your workplace and cannot be invited.",
  "fcd44004d62fa8ea": "Discard shift draft?",
  "fcea6d759b6c1834": "This page has been updated while you were away. Refresh to get the latest.",
  "fcec91509759ad99": "here",
  "fcfdd6491f7b2517": "Close assign Roster drawer",
  "fd11f315e1f2cf34": "Open {{dateLabel}} shifts",
  "fd34be170e1eabc0": "All upcoming shifts for the shift block have been cancelled",
  "fdc923f7b593d952": "{{slotLabel}} shifts, {{filledCount}} filled out of {{totalCount}}",
  "fdeb71b569e0034d": "Sat",
  "fdfd43ff69947f68": "Signed by ",
  "fe8fa011d55a4b13": "{{count}} shift copied",
  "ff19fd8e9b0a3e85": "This isn’t currently supported with Fill Guarantee",
  "ff5956419b448ea0": "Worker gets",
  "ff7ebe47a75b69b6": "{{slotLabel}} end time"
}
